/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BuildingConcernedOwnershipDto } from './buildingConcernedOwnershipDto.model';
import { BudZpochnDto } from './budZpochnDto.model';


/**
 * Detailed information about a building from the Czech cadastral registry (ČÚZK)
 */
export interface BuildingResponseDto { 
    /**
     * Cadastral building identifier (BUD_ID) used across all versions
     */
    budId?: number;
    /**
     * Set of building construction/protection modes (způsob ochrany nemovitosti)
     */
    budZpochns?: Array<BudZpochnDto>;
    /**
     * Administrative district code (CAOBCE_KOD)
     */
    caobceKod?: number;
    /**
     * Administrative district name
     */
    caobceNazev?: string;
    /**
     * House number (číslo domovní)
     */
    cisloDomovni?: number;
    /**
     * List of concerned ownerships - ownership relationships related to this building
     */
    concernedOwnerships?: Array<BuildingConcernedOwnershipDto>;
    /**
     * Temporary building indicator (\'A\' for temporary, null for permanent)
     */
    docasnaStavba?: string;
    /**
     * End date of building version validity period (null if currently valid)
     */
    endDate?: string;
    /**
     * Indicates whether there exists a reported parcel (nahlášená parcela) for this building
     */
    existsReportedParcel?: boolean;
    /**
     * Unique internal building version identifier
     */
    id?: number;
    /**
     * Actual version of building exists
     */
    isDefunct?: boolean;
    /**
     * Building component indicator - if building is part of another structure
     */
    jeSoucasti?: string;
    /**
     * Cadastral area code (KATUZE_KOD) where the building is located
     */
    katuzeKod?: number;
    /**
     * Cadastral area name
     */
    katuzeNazev?: string;
    /**
     * Koeficient budovy k_k1134po (Koeficient dle § 11 odst. 4 nebo 6 zákona)
     */
    kk1134Po?: number | null;
    /**
     * Koeficient budovy k_mist12_3po (Místní Koeficient dle § 11 odst. 4 nebo 6 zákona)
     */
    kmist123Po?: number;
    /**
     * Region name (kraj)
     */
    krajNazev?: string;
    /**
     * Land registry folio number (list vlastnictví)
     */
    lv?: number;
    /**
     * Custom building name/identifier assigned by the user
     */
    name?: string;
    /**
     * Municipality name (obec)
     */
    obecNazev?: string;
    /**
     * District name (okres)
     */
    okresNazev?: string;
    /**
     * Parcel identifier where the building stands
     */
    psId?: number;
    /**
     * Start date of building version validity period
     */
    startDate?: string;
    /**
     * Building type code from cadastral registry (TYPBUD_KOD)
     */
    typbudKod?: number;
    /**
     * Building type name (e.g., \'budova s číslem popisným\', \'budova bez čísla popisného nebo evidenčního\')
     */
    typbudNazev?: string;
    /**
     * Building structure code (ZPVYBU_KOD) - construction type classification
     */
    zpvybuKod?: number;
    /**
     * Building structure name (e.g., \'rodinný dům\', \'zemědělská usedlost\')
     */
    zpvybuNazev?: string;
}

